import {React, Component} from "react";
import Constant from "../common/Constant";


export default class ShowPopup extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return(
            <div className="popup-box  border-0 rd-12">
              <div className="boxModal text-center border-0 pt-20 pb-20 rd-12 wd-320 ht-174 boxTop">
                <p className="text-height-1 mb-20 M1542">
                {this.props.message}

                </p>
                <button
                  className="btn bg-btn-orange wd-126 ht-36 M1542" style={{color: 'white'}}
                  onClick={this.props.onAction}
                >
                  OK
                </button>
              </div>
            </div>
        )
    }
}